var header = $("#page-navigation");
var logo_small = $("#logo-small");
var primary_nav = $("#primary-nav");


$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  var addOverhead = document.querySelector('section.ad.overhead');

  if (addOverhead!==null) {
    var overheadHeight = addOverhead.offsetHeight;

    if (overheadHeight < 62) {
      overheadHeight = 62;
    }

    if (scroll >= overheadHeight) {
      header.addClass("navbar-fixed-top");
      logo_small.show();
      primary_nav.addClass("scrolled");
    } else {
      header.removeClass('navbar-fixed-top');
      logo_small.hide();
      primary_nav.removeClass('scrolled');
    }
  }
});
